import { FC, useMemo, useState } from "react";
import { SiteItem } from "@vviinn/user-managment-client-ts";

import {
  AIMethods,
  configWithSegmentation,
  switchableColorTitles,
  switchableSimilarityTitles,
} from "../../index";

import { isSameEmbedderConfig } from "../../details/modals/helpers";

import { AiMethodsEditBlock } from "./AiMethodsEditBlock";
import { AcceptableNamedRow } from "../../../ui/layout/organisms/SlideOver/SlideOverFixedLayouts/AcceptableNamedRow";
import { HandleRequest } from "../Credentials/types";
import { SubSectionWithStyles } from "../../../ui/layout";

const aiSwitchableTitles = {
  ...switchableSimilarityTitles,
  ...switchableColorTitles,
};
const aiTitles = Object.keys(aiSwitchableTitles) as AIMethods[];

type AIMethodsEditModalProps = HandleRequest & {
  siteDetails: SiteItem;
};

export const AIMethodsBlock: FC<
  React.PropsWithChildren<AIMethodsEditModalProps>
> = ({ siteDetails, handleRequests }) => {
  const initEmbedderConfig = useMemo(
    () => configWithSegmentation(siteDetails),
    [siteDetails],
  );

  const [embeddersConfig, setEmbeddersConfig] = useState(initEmbedderConfig);
  const [useBarraquito, setUseBarraquito] = useState(
    siteDetails.useBarraquito ?? false,
  );

  const activatedAIMethodsCount =
    aiTitles.reduce(
      (prev, current) => (siteDetails[current] ? prev + 1 : prev),
      0,
    ) + Number(siteDetails.useBarraquito ?? 0);

  const initiate = () => {
    setEmbeddersConfig(initEmbedderConfig);
    setUseBarraquito(siteDetails.useBarraquito ?? false);
  };

  return (
    <SubSectionWithStyles title="AI methods">
      <AcceptableNamedRow
        title="Activated AI methods"
        permissionsGroup="site:advanced_config"
        initConfig={initiate}
        allowSubmit={
          !isSameEmbedderConfig(embeddersConfig, initEmbedderConfig) ||
          useBarraquito !== (siteDetails.useBarraquito ?? false)
        }
        content={activatedAIMethodsCount}
        onSubmit={async () =>
          await handleRequests({
            requestType: "AI methods",
            siteBody: {
              id: siteDetails.id,
              embedders: embeddersConfig,
              useBarraquito: useBarraquito,
            },
          })
        }
      >
        <AiMethodsEditBlock
          embeddersConfig={embeddersConfig}
          setEmbeddersConfig={setEmbeddersConfig}
          useBarraquito={useBarraquito}
          setUseBarraquito={setUseBarraquito}
          showInSlideOver={true}
        />
      </AcceptableNamedRow>
    </SubSectionWithStyles>
  );
};
